import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './styles/globals.css';
import App from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

// Vite が base から注入する BASE_URL（本番 '/tochi-check/'、開発 '/'）を
// Router の basename に渡す。末尾スラッシュを除くと、スラッシュ有無どちらの
// URL でもインデックスに解決する（react-router v6 stripBasename）。
// これ一箇所で既存の <Link to="/..."> がすべて subdir 配下に解決する。
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
